const SECRET = "JC_SECRET_2026"; // keep same in backend & frontend

export const encryptId = (id) => {
  const text = `${id}:${SECRET}`;
  return btoa(text); // base64 encode
};

export const decryptId = (hash) => {
  try {
    const decoded = atob(hash); // base64 decode
    const [id, secret] = decoded.split(":");
    if (secret !== SECRET) return null;
    return id;
  } catch (e) {
    return null;
  }
};
